export function isValidURL(input) {
  const trimmedInput = input.trim();
  if (!trimmedInput) {
    return false;
  }
  const hasProtocol = /^https?:\/\//i.test(trimmedInput);
  const urlToTest = hasProtocol ? trimmedInput : `https://${trimmedInput}`;
  try {
    const url = new URL(urlToTest);
    const hostname = url.hostname;
    return hostname.includes('.') && hostname.split('.').every(part => part.length > 0);
  } catch {
    return false;
  }
}
//# sourceMappingURL=validations.js.map